export type ShihuoProductIds = {
  goodsId: number;
  styleId: number;
};

const EXTERNAL_ID_SEPARATOR = ":";

export const parseShihuoExternalId = (
  externalId: string,
): ShihuoProductIds | null => {
  const [goodsId, styleId] = externalId.split(EXTERNAL_ID_SEPARATOR);

  const ids = {
    goodsId: Number(goodsId),
    styleId: Number(styleId),
  };

  const isUsable = (value: number) => Number.isFinite(value) && value > 0;

  return isUsable(ids.goodsId) && isUsable(ids.styleId) ? ids : null;
};
